import React from "react";
import { Phone, Menu, X } from "lucide-react";
import { BUSINESS, TEL_PRIMARY, IMAGES } from "../lib/business";

export default function Header() {
  const [open, setOpen] = React.useState(false);
  const links = [
    { href: "#servicos", label: "Serviços" },
    { href: "#centro-automotivo", label: "Centro Automotivo" },
    { href: "#areas", label: "Áreas Atendidas" },
    { href: "#depoimentos", label: "Depoimentos" },
    { href: "#faq", label: "FAQ" },
  ];

  return (
    <header
      data-testid="site-header"
      className="fixed top-0 left-0 right-0 z-40 bg-white border-b-2 border-[#E50914] shadow-md"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 h-16 md:h-20 flex items-center justify-between">
        <a href="#top" className="flex items-center gap-3" data-testid="header-logo">
          <div className="p-1">
            <img src={IMAGES.logo} alt="Refúgio Guincho logo" className="h-10 md:h-12 w-auto" />
          </div>
          <div className="hidden sm:block leading-tight">
            <div className="font-anton text-xl md:text-2xl text-black uppercase">Refúgio Guincho</div>
            <div className="font-work text-[10px] md:text-xs text-[#E50914] uppercase tracking-[0.2em] font-bold">
              24h · Menor Preço
            </div>
          </div>
        </a>

        <nav className="hidden lg:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="font-work text-sm uppercase tracking-wider text-zinc-800 hover:text-[#E50914] transition-colors font-semibold"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href={TEL_PRIMARY}
            data-testid="header-call-button"
            className="hidden md:flex items-center gap-2 bg-[#E50914] hover:bg-[#B80710] text-white font-anton uppercase px-5 py-3 text-base tracking-wider transition-all hover:-translate-y-0.5 rounded-sm"
          >
            <Phone className="w-4 h-4" strokeWidth={2.5} />
            {BUSINESS.phonePrimary}
          </a>
          <button
            onClick={() => setOpen(!open)}
            data-testid="mobile-menu-toggle"
            className="lg:hidden text-black p-2"
            aria-label="Abrir menu"
          >
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {open && (
        <div className="lg:hidden bg-white border-t border-zinc-200 px-4 py-4 flex flex-col gap-2">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="font-work text-base uppercase tracking-wider text-black hover:text-[#E50914] py-2 font-semibold"
            >
              {l.label}
            </a>
          ))}
          <a
            href={TEL_PRIMARY}
            data-testid="mobile-menu-call-button"
            className="mt-2 flex items-center justify-center gap-2 bg-[#E50914] text-white font-anton uppercase px-5 py-3 text-base tracking-wider"
          >
            <Phone className="w-4 h-4" />
            {BUSINESS.phonePrimary}
          </a>
        </div>
      )}
    </header>
  );
}
